import { useTranslation } from 'react-i18next';
import styles from './autodesk-opportunities.module.scss';
import FullTable from '../full-table/full-table';
import { booleanHeader, Box, CreateHeaders, dateHeader, Dialog, DialogActions, DialogContent, DialogTitle, ErrorButton, HeaderSizeEnum, SuccessButton, TextField, textHeader } from '@frontend-workspace/react-shared-lib';
import WebkuaTable from '../webkua-table/webkua-table';
import { GetCurrentCompany } from '../customer-context/customer-context';
import { useState } from 'react';
import { useGetRequestNewHook, useMakeRequestHook, useTableConfigHook } from '../requestUtils';
import { ValueFormatterFunc, ValueFormatterParams } from 'ag-grid-community';

/* eslint-disable-next-line */
export interface AutodeskOpportunitiesProps { }

interface IOpportunities {

}
export function AutodeskOpportunities(props: AutodeskOpportunitiesProps) {
  const { t } = useTranslation();
  const currentCompany = GetCurrentCompany();
  const makeRequest = useMakeRequestHook();
  const [isGroup, setIsGroup] = useState<boolean>(false);
  const companyNumber = currentCompany ? currentCompany.number : "";
  const url = currentCompany ? `companies/action/getADOpportunities/${companyNumber}/forGroup/${isGroup}` : "companies/action/getADOpportunities";
  const tableConfig = useTableConfigHook("ADOpportunities");
  const handleIsGroupToggle = () => setIsGroup(!isGroup);
  const [selectedOpportunity, setSelectedOpportunity] = useState<any>(null);

  const { data: opportunities, getData, isLoading }: { data: IOpportunities[], getData: () => void, isLoading: boolean } = useGetRequestNewHook(url, undefined, [currentCompany, isGroup]);
  const handleDialogClose = () => setSelectedOpportunity(null);
  const sendRequest = (opportunityId: string, customerRef: string) => makeRequest(`autodesk/action/sendopportunityorder`, 'POST', { opportunityId, customerRef }).then(() => getData());
  const createOrderRenderer = (params: ValueFormatterParams) => {
    const onClick = () => setSelectedOpportunity(params.data);
    const hasExistingOrder = params.data.hasExistingOrder;
    return <SuccessButton
      onClick={onClick}
      variant='contained'
    >
      {hasExistingOrder ? t("autodeskOpportunities.hasExistingOrder") : t("autodeskOpportunities.createOrder")}
    </SuccessButton>
  };
  return <>
    <WebkuaTable
      onRefresh={getData}
      isLoading={isLoading}
      headers={CreateHeaders([
        textHeader("address", t("standard.address"), HeaderSizeEnum.LARGE, { renderer: "agGroupCellRenderer" }),
        textHeader("csn", "CSN"),
        textHeader("companyName", t("standard.name")),
        textHeader("companyNumber", t("standard.companyNumber")),
        textHeader("contractManagerEmail", t("autodeskOpportunities.contractManagerEmail")),
        textHeader("contractManagerName", t("autodeskOpportunities.contractManagerName")),
        textHeader("status", t("autodeskOpportunities.status"), HeaderSizeEnum.MEDIUM),
        textHeader("quantity", t("autodeskOpportunities.quantity")),
        textHeader("costPrice", t("autodeskOpportunities.purPriceEur")),
        textHeader("renewalSkus", t("autodeskOpportunities.renewalSkus")),
        textHeader("skuDescriptions", t("autodeskOpportunities.skuDescriptions")),
        textHeader("customerRef", t("autodeskOpportunities.customerRef")),
        dateHeader("subscriptionEndDate", t("autodeskOpportunities.endDate")),
        booleanHeader("hasExistingOrder", "Has Existing Order"),
        textHeader("id", "", HeaderSizeEnum.MEDIUM, { renderer: createOrderRenderer })
      ])}
      expandComponent={RowExpandComponent}
      tableConfig={tableConfig}
      pageSize={15}
      data={opportunities}
      tableFilters={[{
        label: t("standard.showForGroup"),
        checked: isGroup,
        onChange: handleIsGroupToggle
      }]}
    />
    {selectedOpportunity && <OrderDialog opportunity={selectedOpportunity} onSend={sendRequest} onClose={handleDialogClose} />}
  </>
}
function RowExpandComponent(props: any) {
  const { t } = useTranslation();
  return <Box className="container-fluid p-xl-4">
    <WebkuaTable
      data={props.data.lineItems}
      headers={CreateHeaders([
        textHeader("purPriceEur", t("autodeskOpportunities.purPriceEur")),
        textHeader("quantity", t("standard.quantity")),
        textHeader("renewal_sku", t("autodeskOpportunities.renewalSku")),
        textHeader("sku_description", t("autodeskOpportunities.skuDescription"), HeaderSizeEnum.EXTRA_LARGE),
        textHeader("status", t("autodeskOpportunities.status"))

      ])}
    />
  </Box>
}
function OrderDialog(props: {
  opportunity: any,
  onClose: () => void,
  onSend: (opportunityId: string, customerRef: string) => void
}) {
  const [customerRef, setCustomerRef] = useState<string>(props.opportunity.customerRef);
  const handleSend = () => {
    props.onSend(props.opportunity.id, customerRef);
    props.onClose();
  }
  return <Dialog open maxWidth="lg">
    <DialogTitle>{`Opprett vismaordre for opportunity ${props.opportunity.id}`}</DialogTitle>
    <DialogContent>
      {props.opportunity.hasExistingOrder && <>
        <p>Opportunitien er allerede sendt til Visma.</p>
        <p>Er du sikker på at du vil sende den igjen?</p>
      </>}
      <TextField
        value={customerRef}
        onChange={e => setCustomerRef(e.target.value)}
        label="Kundereferanse"
      />
    </DialogContent>
    <DialogActions>
      <SuccessButton onClick={handleSend} variant='contained'>Send til Visma</SuccessButton>
      <ErrorButton onClick={props.onClose} variant='contained'>Avbryt</ErrorButton>
    </DialogActions>
  </Dialog>
}

export default AutodeskOpportunities;
